"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableBody_1 = __importDefault(require("@mui/material/TableBody"));
const TableCell_1 = __importStar(require("@mui/material/TableCell"));
const TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const material_1 = require("@mui/material");
const TextHelper_1 = require("../widget/services/TextHelper");
const useConfig_1 = require("../widget/hooks/useConfig");
const FeeTable = ({ config, showPerTerm = false }) => {
    let feeTableConfig = config;
    if (!feeTableConfig) {
        feeTableConfig = (0, useConfig_1.useConfig)();
        if (feeTableConfig == null)
            return;
    }
    const StyledTableRow = (0, material_1.styled)(TableRow_1.default)(({ theme }) => ({
        '&:nth-of-type(even)': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));
    const calculateFees = (fee) => {
        const { amt, freq } = fee;
        const perAnnum = amt * freq;
        const perTerm = perAnnum / 4;
        return {
            perTerm: (0, TextHelper_1.formatNumberCurrency)(perTerm, 'ifPresent', feeTableConfig.terms),
            perAnnum: (0, TextHelper_1.formatNumberCurrency)(perAnnum, 'ifPresent', feeTableConfig.terms),
        };
    };
    // Group gradeFees by site
    const groupedFees = feeTableConfig.fees.gradeFees
        ? feeTableConfig.fees.gradeFees.reduce((acc, fee) => {
            const site = fee.site || 'default';
            if (!acc[site])
                acc[site] = [];
            acc[site].push(fee);
            return acc;
        }, {})
        : {};
    // Get site label from config.fees.sites
    const getSiteLabel = (siteId) => {
        var _a;
        const site = (_a = feeTableConfig.fees.sites) === null || _a === void 0 ? void 0 : _a.find((s) => s.id === siteId);
        return site ? `${feeTableConfig.name} (${site.label})` : feeTableConfig.name;
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: Object.entries(groupedFees).map(([site, fees]) => ((0, jsx_runtime_1.jsx)(TableContainer_1.default, { sx: { marginBottom: 4 }, children: (0, jsx_runtime_1.jsxs)(Table_1.default, { sx: {
                    [`& .${TableCell_1.tableCellClasses.root}`]: {
                        borderBottom: 'none',
                    },
                }, children: [(0, jsx_runtime_1.jsx)(TableHead_1.default, { children: (0, jsx_runtime_1.jsxs)(TableRow_1.default, { sx: {
                                backgroundColor: (theme) => theme.palette.action.hover,
                                borderTop: `4px solid ${feeTableConfig.theme.primary}`,
                            }, children: [(0, jsx_runtime_1.jsxs)(TableCell_1.default, { sx: { fontWeight: 'bold' }, children: [' ', getSiteLabel(site)] }), showPerTerm && ((0, jsx_runtime_1.jsx)(TableCell_1.default, { sx: { fontWeight: 'bold' }, align: "right", children: "Tuition Fee per Term" })), (0, jsx_runtime_1.jsx)(TableCell_1.default, { sx: { fontWeight: 'bold' }, align: "right", children: "Tuition Fee per Year" })] }) }), (0, jsx_runtime_1.jsx)(TableBody_1.default, { children: fees.map((fee, index) => ((0, jsx_runtime_1.jsxs)(StyledTableRow, { children: [(0, jsx_runtime_1.jsxs)(TableCell_1.default, { children: [fee.label, ' ', fee.variantLabel ? `(${fee.variantLabel})` : ''] }), showPerTerm && ((0, jsx_runtime_1.jsx)(TableCell_1.default, { align: "right", children: calculateFees(fee).perTerm })), (0, jsx_runtime_1.jsx)(TableCell_1.default, { align: "right", children: calculateFees(fee).perAnnum })] }, index))) })] }) }, site))) }));
};
exports.default = FeeTable;
